import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  CircularProgress
} from '@material-ui/core';
import api from 'utils/api';
import { toast } from 'utils/helpers';

const DocumentListDialog = ({ open, onClose, onSelect, loadedDocumentIds, mainDocumentId }) => {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (open) {
      // Initialize selectedIds with currently loaded documents
      setSelectedIds([...loadedDocumentIds]);
      fetchDocuments();
    }
  }, [open, loadedDocumentIds]);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/documents');

      const validDocs = data.data ? data.data : (Array.isArray(data) ? data : []);

      const ifcDocs = validDocs.filter(doc => doc.type.toLowerCase() === 'ifc');

      setDocuments(ifcDocs);
    } catch (err) {
      console.error(err);
      toast(t('Nepavyko gauti dokumentų sąrašo'), 'error');
    }
    setLoading(false);
  };

  const handleToggle = (value) => () => {
    // Prevent toggling the main document
    if (value === mainDocumentId) return;

    const currentIndex = selectedIds.indexOf(value);
    const newChecked = [...selectedIds];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedIds(newChecked);
  };

  const handleConfirm = () => {
    // Find document objects for selected IDs
    const selectedDocs = documents.filter(doc => selectedIds.includes(doc._id));
    onSelect(selectedDocs);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Pasirinkite dokumentus')}</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
            <CircularProgress />
          </div>
        ) : (
          <List>
            {documents.length === 0 && <div style={{ textAlign: 'center', padding: 20 }}>{t('Nėra papildomų IFC dokumentų')}</div>}
            {documents.map((doc) => {
              const labelId = `checkbox-list-label-${doc._id}`;
              const isMain = doc._id === mainDocumentId;

              return (
                <ListItem key={doc._id} role={undefined} dense button onClick={handleToggle(doc._id)} disabled={isMain}>
                  <Checkbox
                    edge="start"
                    checked={selectedIds.indexOf(doc._id) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                    disabled={isMain}
                  />
                  <ListItemText 
                    id={labelId} 
                    primary={doc.name || doc.title} 
                    secondary={isMain ? t('Pagrindinis dokumentas') : null}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('Atšaukti')}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          {t('Išsaugoti')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentListDialog;